export default __webpack_public_path__ + "static/media/ER_Icon.0b404c86.svg";